import ReactOnRails from 'react-on-rails';

import About from '@components/pages/About/index';

ReactOnRails.register({
  About,
});

